import fetch from 'services/request';
import { IApiCreateStoreBody, IApiGetListScreensInStoreParam, IApiGetListStoresParam, IApiGetMediaInStoreParam, ICreateStoreRequest, IResetPasswordBody, ISyncStoreRequest } from '../interfaces/api';

// const baseURL = 'api/v1/:merchant_code/demoData';

export const getDemoData = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ data: { data: [] } });
    }, 1000);
  });
};

const createStore = (data: ICreateStoreRequest) => {
  return fetch({
    method: 'post',
    url: '/api/v1/manage-store/create',
    body: data,
  });
};

const getListStores = (params: IApiGetListStoresParam) => {
  return fetch({
    method: 'get',
    url: '/api/v1/manage-store/list',
    params,
  });
};

const updateStore = (data: IApiCreateStoreBody) => {
  return fetch({
    method: 'put',
    url: '/api/v1/manage-store/update',
    body: data,
  });
};

const deleteStore = (storeId: string) => {
  return fetch({
    method: 'delete',
    url: `/api/v1/manage-store/delete/${storeId}`,
  });
};

const getListScreensInStore = (params: IApiGetListScreensInStoreParam) => {
  return fetch({
    method: 'get',
    url: '/api/v1/manage-screen/list',
    params,
  });
};

const getListTimezones = () => {
  return fetch({
    method: 'get',
    url: '/api/v1/manage-store/list-timezone',
  });
};

const syncStore = (data: ISyncStoreRequest) => {
  return fetch({
    method: 'post',
    url: '/api/v1/manage-store/sync',
    body: data,
  });
};

const resetPassword = (data: IResetPasswordBody) => {
  return fetch({
    method: 'post',
    url: '/api/v1/manage-store/reset-password',
    body: data,
  });
};

const detailStore = (storeId: string) => {
  return fetch({
    method: 'get',
    url: `/api/v1/manage-store/detail/${storeId}`,
  });
};

const getAllStores = () => {
  return fetch({
    method: 'get',
    url: '/api/v1/manage-store/list',
    params: { page: 1, size: 1000 },
  });
};

const getMediaInStore = (body: IApiGetMediaInStoreParam) => {
  return fetch({
    method: 'post',
    url: '/api/v1/manage-library',
    body,
  });
};

const getSummaryStore = (storeId: string) => {
  return fetch({
    method: 'get',
    url: `/api/v1/manage-store/summary/${storeId}`,
  });
};

const storeApis = {
  getDemoData,
  getListStores,
  createStore,
  updateStore,
  deleteStore,
  getListScreensInStore,
  getListTimezones,
  syncStore,
  resetPassword,
  detailStore,
  getAllStores,
  getMediaInStore,
  getSummaryStore,
};

export default storeApis;
